module.exports = __webpack_public_path__ + "img/medical-history.347b461d.svg";